// LA ETIQUETA QUE SE LEE CON LA CÁMARA DEL TELÉFONO · AC-15 (1 oct 2026).
//
// Las etiquetas de TEGO llevan una URL dentro del QR:
//   · producto: `<origen>/q/<qr_tego del producto>`  (Accesos Fase 4)
//   · pieza:    `<origen>/qp/<qr_tego de la pieza>`   (AC-15, migración 250)
// La cámara nativa del teléfono abre esa dirección en el navegador. nginx
// devuelve la consola para cualquier ruta, así que llega aquí.
//
// LO QUE FALTABA, y no solo para las piezas: ninguna pantalla leía esas
// rutas. La URL del producto abría la consola en su pantalla de inicio,
// no en el producto. Ahora las dos se traducen a `?m=escanear` con la URL
// entera como lectura: es exactamente lo que el escáner de dentro de la
// app manda al resolvedor, así que es una sola puerta y no dos.
//
// SIN SESIÓN, la dirección espera mientras la persona entra (lo mismo que
// las ligas de los correos): `AppShell` la lee al montarse.
import { CLAVE_MODULO } from '../lib/urlEstado';
import { reescribirUrlEn } from '../ui/navegacion';

export const PREFIJOS = { '/q/': 'PRODUCTO', '/qp/': 'PIEZA' };

// La clave de la dirección que lleva la lectura hasta «Escanear».
export const CLAVE_ETIQUETA = 'etiqueta';
const MODULO = 'escanear';

/** `{ tipo, codigo }` si la ruta es la de una etiqueta de TEGO; si no, null. */
export function leerEnlaceDeEtiqueta(camino) {
  for (const [prefijo, tipo] of Object.entries(PREFIJOS)) {
    if (typeof camino === 'string' && camino.startsWith(prefijo)) {
      let codigo = camino.slice(prefijo.length).replace(/\/+$/, '');
      try { codigo = decodeURIComponent(codigo); } catch { /* se queda tal cual */ }
      codigo = codigo.trim().slice(0, 100);
      if (!codigo || codigo.includes('/')) return null;
      return { tipo, codigo, prefijo };
    }
  }
  return null;
}

/** El texto que va dentro del QR de una etiqueta del visor. */
export function contenidoDelQR(etiqueta, origen) {
  const base = origen ?? ((typeof window !== 'undefined' && window.location.origin) || '');
  if (etiqueta?.tipo === 'PIEZA' && etiqueta.qr_tego) {
    return `${base}/qp/${etiqueta.qr_tego}`;
  }
  return etiqueta?.codigo ?? '';
}

/**
 * Si la dirección es `/q/<código>` o `/qp/<código>`, la cambia (sin dejar
 * rastro en el historial) por `/app?m=escanear&etiqueta=<URL entera>`.
 * Devuelve lo que leyó, o null si no era una etiqueta.
 */
export function llevarEnlaceAEscanear(win = window) {
  const leido = leerEnlaceDeEtiqueta(win.location.pathname);
  if (!leido) return null;
  try {
    const q = new URLSearchParams();
    q.set(CLAVE_MODULO, MODULO);
    q.set(CLAVE_ETIQUETA, `${win.location.origin}${leido.prefijo}${leido.codigo}`);
    // Sin borrar el state de la entrada (TC-DR-AT).
    reescribirUrlEn(win, `/app?${q.toString()}`);
  } catch { /* sin historial, se queda donde estaba */ }
  return leido;
}

/**
 * El contexto con el que nace «Escanear» cuando se llegó por una etiqueta:
 * `{ codigo: <URL> }`, que la pantalla resuelve al montarse. Solo si el
 * módulo que se abre es justo ése; si el rol no lo tiene, nada.
 */
export function contextoDeEtiqueta(moduloActivo, busqueda) {
  if (moduloActivo !== MODULO) return null;
  try {
    const q = new URLSearchParams(busqueda ?? window.location.search);
    if (q.get(CLAVE_MODULO) !== MODULO) return null;
    const codigo = (q.get(CLAVE_ETIQUETA) || '').trim();
    return codigo ? { codigo } : null;
  } catch { return null; }
}
